import { dynamicLoader } from '~/utils';

export const ManyToManyGrid = dynamicLoader({
  name: 'ManyToManyGrid',
  importFunc: () => import('./many-to-many-grid'),
});